"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const youtube_1 = __importDefault(require("react-player/youtube"));
require("./YoutubeModal.scss");
const YoutubeModal = ({ visible, videoId, closeButtonText, onHideModal, youtubeBlockedText, youtubeBlockedCookieSettingBtnText }) => {
    let youtubeAllowed = true;
    try {
        //@ts-ignore
        if (OnetrustActiveGroups) {
            //@ts-ignore
            youtubeAllowed = OnetrustActiveGroups.indexOf('C0004') !== -1;
        }
    }
    catch (_a) { }
    const openCookieSettings = () => {
        document.querySelector("#ot-sdk-btn").click();
        onHideModal();
    };
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: visible, onHide: onHideModal, centered: true, size: "xl", dialogClassName: "youtube-modal-container" },
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "position-relative" },
            react_1.default.createElement("button", { className: "btn position-absolute youtube-modal-button", onClick: onHideModal },
                react_1.default.createElement("span", { className: "text-white text-16" }, closeButtonText || 'Close'),
                react_1.default.createElement("span", { "aria-hidden": true, className: "icon-close text-white" })),
            react_1.default.createElement("div", { className: "ratio ratio-16x9" }, youtubeAllowed ?
                react_1.default.createElement(youtube_1.default, { url: `https://www.youtube.com/watch?v=${videoId}`, width: "100%", height: "100%", controls: true })
                :
                    react_1.default.createElement("div", { role: 'alertdialog', className: 'd-flex flex-column align-items-center justify-content-center px-4' },
                        react_1.default.createElement("p", { className: 'text-center px-8 px-sm-10' }, youtubeBlockedText),
                        react_1.default.createElement("button", { id: "ot-sdk-btn", className: "ot-sdk-show-settings btn btn-sampo-outline-primary", onClick: openCookieSettings }, youtubeBlockedCookieSettingBtnText))))));
};
exports.default = YoutubeModal;
